import React from 'react';

import GlobalStyles from './GlobalStyles';
import { ThemeProvider } from './ThemeContext';

function App({ children }) {
	return (
		<React.StrictMode>
			<ThemeProvider>
				<GlobalStyles />
				{children}
			</ThemeProvider>
		</React.StrictMode>
	);
}

export default App;
